import { LazyMotion, MotionConfig, domMax } from 'motion/react'
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { LocaleProvider } from '../lib/i18n.tsx'
import { ToastProvider } from '../kit/Toast.tsx'
import type { createAppRouter } from './router.tsx'

/** Providers, outermost first: data, language, motion (reduced motion respected), toasts, then the router. */
export function App({ queryClient, router }: { queryClient: QueryClient; router: ReturnType<typeof createAppRouter> }) {
  return (
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <MotionConfig reducedMotion="user">
          <LazyMotion features={domMax}>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </LazyMotion>
        </MotionConfig>
      </LocaleProvider>
    </QueryClientProvider>
  )
}
